import { Rating } from "./Rating";
import { ReactComponent as MenuDotsIcon } from "../../../../assets/icons/menu-dots.svg";
import { ReactComponent as HeartIcon } from "../../../../assets/icons/heart.svg";
import { ReactComponent as BookmarkIcon } from "../../../../assets/icons/bookmark.svg";
import { ReactComponent as CommentsIcon } from "../../../../assets/icons/comments.svg";

import { TABS } from "./Tabs";
import { ImageListView } from "../../../../components/ImageListView";
import moment from "moment";
import UIPopover from "../../../../components/Popover";
import { Button } from "../../../../components/Button";
import { getMentions } from "../../../../helpers/utils";

export function PostCard({
  type,
  post,
  user,
  refresh,
  onPostDelete,
  postDeleteLoading,
  isSalon,
}: {
  type: string;
  post: any;
  user: any;
  refresh: any;
  onPostDelete?: any;
  postDeleteLoading?: boolean;
  isSalon?: boolean;
}) {
  const postUser =
    type === TABS.REVIEWS
      ? post?.reviewer
      : [TABS.LIKED, TABS.SAVED].includes(type)
      ? post?.user
      : user;
  return (
    <div className="w-[400px] h-fit p-4 rounded-[20px] border border-[#e2e2e2] flex-col justify-start items-start gap-2.5 flex">
      <div className="w-full flex-col justify-start items-start gap-[13px] flex">
        <div className="w-full justify-between items-start flex">
          <div className="justify-start items-center gap-[9px] flex">
            <img
              className="w-[35px] h-[35px] rounded-full border-2 border-white"
              src={postUser?.profileImg}
              alt="profile-image"
            />
            <div className="flex-col justify-start items-start gap-1.5 flex">
              <div className="text-black text-xs font-normal poppins">
                {postUser?.fullName}
              </div>
              <div className="opacity-40 text-black text-[10px] font-normal poppins">
                @{postUser?.username}
              </div>
            </div>
          </div>
          <div className="justify-start items-start gap-2.5 flex">
            <div className="opacity-40 text-right text-black text-[10px] font-normal poppins">
              {isSalon
                ? moment(post.createdAt).format("MMM DD, YYYY")
                : moment(post.createdAt).fromNow()}
            </div>
            {onPostDelete && (
              <UIPopover
                trigger={
                  <Button
                    variant="outline"
                    className="h-[2.5rem] relative w-[2.5rem] !border-0 !bg-transparent flex !p-2 !pt-0 items-center justify-center  [&_path]:hover:fill-black/20"
                  >
                    <MenuDotsIcon className="w-6 h-6 absolute -top-1" />
                  </Button>
                }
                containerClassName="z-[99]"
              >
                {(close) => (
                  <div className="flex flex-col gap-4 bg-white p-4 rounded-lg shadow-[0px_6px_26px_0px_rgba(28,43,40,0.14)] font-inter mr-4 text-sm">
                    <button
                      type="button"
                      className="text-[#F54343] text-start"
                      onClick={() => {
                        close();
                        // setIsDeleteModalOpen(true);
                        onPostDelete(post);
                      }}
                    >
                      Delete post
                    </button>
                  </div>
                )}
              </UIPopover>
            )}
          </div>
        </div>
        <div className="flex-col justify-start items-start gap-3.5 flex w-full">
          <div className="flex-col justify-start items-start gap-[9px] flex w-full">
            {type === TABS.REVIEWS ? (
              <>
                <div className="items-center gap-1.5 flex">
                  <Rating rating={post?.rating || 0} />
                  <div className="text-black text-xs font-medium poppins uppercase leading-[18px]">
                    {(post?.rating || 0).toFixed(1)}
                  </div>
                </div>
                {!isSalon && post?.reviewFor && (
                  <div className="self-stretch pl-2 pr-[9px] py-2 bg-[#dddddd]/40 rounded-lg justify-start items-center gap-[9px] inline-flex">
                    <img
                      className="w-[25px] h-[25px] rounded-full"
                      src={post?.reviewFor?.profileImg}
                    />
                    <div className="justify-start items-center gap-1.5 flex">
                      <div className="text-black text-sm font-normal poppins">
                        {post?.reviewFor?.fullName}{" "}
                      </div>
                      <div className="opacity-40 text-black text-xs font-normal poppins">
                        (
                        {post?.reviewFor?.userType === "SA"
                          ? "Salon"
                          : "Artist"}
                        )
                      </div>
                    </div>
                  </div>
                )}

                <div
                  dangerouslySetInnerHTML={{ __html: post.review }}
                  className="self-stretch italic"
                />

                {post?.images?.length > 0 && (
                  <ImageListView
                    images={post.images}
                    className="w-[368px] h-[256px] rounded-[9px]"
                  />
                )}
              </>
            ) : (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: getMentions(post?.content || ""),
                  }}
                  className="text-sm poppins text-black"
                />
                {post?.images?.length > 0 && (
                  <ImageListView
                    images={post.images}
                    className="w-[368px] h-[256px] rounded-[9px]"
                  />
                )}
                <div className="flex-1 justify-between items-center flex w-full">
                  <div className="justify-start items-start gap-2.5 flex">
                    <div className="justify-start items-center gap-[3px] flex">
                      <HeartIcon className="w-5 h-5" />
                      <div className="text-black text-[11px] font-normal font-['Poppins']">
                        {post?.likesCount}
                      </div>
                    </div>
                    <div className="justify-start items-center gap-[3px] flex">
                      <CommentsIcon className="w-5 h-5" />
                      <div className="text-black text-[11px] font-normal font-['Poppins']">
                        {post?.commentsCount}
                      </div>
                    </div>
                  </div>
                  <div className="h-5 justify-end items-center gap-0.5 flex">
                    <BookmarkIcon className="w-5 h-5" />
                    <div className="text-black text-[11px] font-normal font-['Poppins']">
                      24
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* {isDeleteModalOpen && (
        <ConfirmDeletePost
          onClose={() => setIsDeleteModalOpen(false)}
          refetch={refresh}
          postId={post.id}
          onDelete={() => onPostDelete(post)}
          isLoading={postDeleteLoading}
        />
      )} */}
    </div>
  );
}
